import React from "react";
import TimereportKitSupportSearch from "./TimereportKitSupportSearch/TimereportKitSupportSearch";

type Props = {
  onOpen: (id: string, tab?: string) => void;
  onEdit: (id?: string) => void;
};

export const TimereportKitFlowSearch = ({ onOpen, onEdit }: Props) => {
  const props = { onOpen, onEdit };

  return <TimereportKitSupportSearch {...props} />;
};
